// Adds accessibility
jQuery(document).ready(function ($) {
    $('.bocss-checkbox__label').keypress(function (e) {
        if (e.key === ' ' || e.key === 'Enter' || e.key === 'Spacebar') {
            if ($(this).parent().find('input').is(':checked')) {
                $(this).parent().find('label').attr('aria-selected', false);
            } else {
                $(this).parent().find('label').attr('aria-selected', true);
            }
            $(this).click();
            return false;
        }
    });

    $('.bocss-checkbox__group div input:checkbox').click(function () {
        if ($(this).is(':checked')) {
            $(this).parent().find('label').attr('aria-selected', true);
        } else {
            $(this).parent().find('label').attr('aria-selected', false);
        }
    });
});
